import { render, staticRenderFns } from "./ConfirmPhoneViaCall.vue?vue&type=template&id=40336c10&scoped=true&"
import script from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPhoneViaCall.vue?vue&type=style&index=0&id=40336c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40336c10",
  null
  
)

export default component.exports